import { html } from 'lit';
const MoveToLeftDuotone =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M7.5 4.75A.75.75 0 0 0 6.75 4h-1A1.75 1.75 0 0 0 4 5.75v13c0 .966.784 1.75 1.75 1.75h1a.75.75 0 0 0 0-1.5h-1a.25.25 0 0 1-.25-.25v-13a.25.25 0 0 1 .25-.25h1a.75.75 0 0 0 .75-.75m2.397 4.924a.75.75 0 0 1 .096 1.056l-.642.77h3.399a.75.75 0 0 1 0 1.5H9.351l.642.77a.75.75 0 1 1-1.152.96l-1.667-2a.75.75 0 0 1 0-.96l1.667-2a.75.75 0 0 1 1.056-.096M14.75 4A1.75 1.75 0 0 0 13 5.75V8.5a.75.75 0 0 0 1.5 0V5.75a.25.25 0 0 1 .25-.25h3a.25.25 0 0 1 .25.25v13a.25.25 0 0 1-.25.25h-3a.25.25 0 0 1-.25-.25V16a.75.75 0 0 0-1.5 0v2.75c0 .966.784 1.75 1.75 1.75h3a1.75 1.75 0 0 0 1.75-1.75v-13A1.75 1.75 0 0 0 17.75 4z" clip-rule="evenodd"/>
  </svg>
`;
export default MoveToLeftDuotone;
